import { ApolloCache } from '@apollo/client';

import { CatalogVariantFragmentFragment as IVariantFragment } from '@notino/shared/definitions/types';

import variantFragment from '@containers/ProductDetailContainer/queries/fragCatalogVariant.graphql';

export const updateVariantWishlistedCache = ({
  wishlisted,
  cache,
  productId,
}: {
  productId: string | number;
  wishlisted: boolean;
  cache: ApolloCache<object>;
}) => {
  cache.updateFragment<IVariantFragment>(
    {
      fragment: variantFragment,
      id: `CatalogVariant:${productId}`,
    },
    (prev) =>
      prev
        ? {
            ...prev,
            wishlisted,
          }
        : prev
  );
};
